export default __webpack_public_path__ + "static/media/world.db7cf028.svg";